import React from 'react';
import AuditCommission from '../../components/Franchise/AuditCommission';

export default function AuditCommisionPage() {
	return <AuditCommission />;
}
